import React from 'react';
import { ProgressBadge } from '../ProgressBadge';

export const ProgressBar = ({width, badge}) => (
	<div id="form-progress-bar-wrapper">
		<div id="form-progress">
			<figure id="progress-bar">
				<span id="progress-meter" style={{width: `${width}%`}}></span>
				{badge ? (
					<ProgressBadge value={badge} />
				) : (false)}
				<figcaption>Progress &nbsp;<span className="accessibility-hidden">25% finished</span></figcaption>
			</figure>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.js